import { Exclude, Expose, Transform, TransformFnParams, Type } from 'class-transformer';
import { UploadFileError, UploadFileState } from '../type';
import { BaseModel } from '@core/data-access';
import { Default } from '@core/util';

@Exclude()
export class UploadFileModel extends BaseModel {
  /**
   * Random ID of file in array
   */
  @Expose() @Default(null) id!: string;

  /**
   * Path to file in S3
   *
   * Has value when file has been uploaded to S3
   */
  @Expose() @Default(null) key?: string;

  /**
   * Original file name will upload to S3
   */
  @Expose() @Default(null) fileName!: string;

  /**
   * Have value when uploading the file to S3.
   * After upload error/completed, please set this is null
   */
  @Expose() @Default(null) state!: UploadFileState | null;

  /**
   * Have value when validation the file or Upload the file error
   * After the file is valid/upload file completed, please set this is null
   */
  @Expose() @Default(null) error!: UploadFileError | null;

  /**
   * File has been uploaded to S3
   */
  @Expose() @Default(false) isExistFile!: boolean;

  /**
   * File content type
   */
  @Expose() @Default(null) contentType?: string;

  /**
   * File needs to be uploaded to S3
   *
   * Has value when file has not been uploaded to S3
   */
  @Expose()
  @Type(() => Object)
  @Transform((params: TransformFnParams) => params.obj[params.key])
  @Default(null)
  file?: File;
}
